import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { JRL_MARKETING_SITE_URL, PGA_COM_HOST } from 'env'
import ArrowForwardIcon from 'components/material-symbol/icons/ArrowForward'
import SearchIcon from 'components/material-symbol/icons/Search'
import EmojiEventsIcon from 'components/material-symbol/icons/EmojiEvents'
import CelebrationIcon from 'components/material-symbol/icons/Celebration'
import discoverFindCoachHeaderImage from 'images/discover-find-coach-header.png'
import SessionSectionHeader from '../sessions/session-section-header'
import { useStyles } from './styles'

const COACH_SEARCH_URL = `${PGA_COM_HOST}/coaches/search`
const JR_LEAGUE_URL = JRL_MARKETING_SITE_URL
const PROGRAMS_URL = `${PGA_COM_HOST}/coaches/programs`
const COACH_CALLOUT_HEADER_ALT =
  'PGA Coach instructing a student during a golf lesson'
const COACH_CALLOUT_HEADER_POSITION = 'center 30%'

const DiscoverFeatureCard = ({
  eyebrow,
  title,
  description,
  buttonLabel,
  href,
  icon: Icon,
  testId,
  classes,
}) => (
  <Box className={classes.featureCard} data-testid={testId}>
    <Box className={classes.featureCardHeader}>
      <Box className={classes.iconCircle}>
        <Icon fontSize="small" opticalSize={20} />
      </Box>
      <Box className={classes.featureCardHeading}>
        <Typography component="p" className={classes.eyebrow}>
          {eyebrow}
        </Typography>
        <Typography component="h3" className={classes.cardTitle}>
          {title}
        </Typography>
      </Box>
    </Box>
    <Typography component="p" className={classes.cardDescription}>
      {description}
    </Typography>
    <Button
      className={classes.cardLink}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      endIcon={<ArrowForwardIcon fontSize="small" opticalSize={16} />}
    >
      {buttonLabel}
    </Button>
  </Box>
)

const CoachCalloutCard = ({ classes }) => (
  <Box
    className={classes.coachCallout}
    data-testid="discover-more-golf-coach-search"
  >
    <Box
      className={classes.coachCalloutHeaderImage}
      style={{
        backgroundImage: `url(${discoverFindCoachHeaderImage})`,
        backgroundPosition: COACH_CALLOUT_HEADER_POSITION,
      }}
      role="img"
      aria-label={COACH_CALLOUT_HEADER_ALT}
    />
    <Box className={classes.coachCalloutBody}>
      <Typography component="p" className={classes.eyebrow}>
        Find your fit
      </Typography>
      <Typography component="h3" className={classes.coachCalloutTitle}>
        A PGA Coach for every game
      </Typography>
      <Typography component="p" className={classes.coachCalloutDescription}>
        Search thousands of PGA Professionals near you — filter by specialty,
        price and availability, and book your first lesson in minutes.
      </Typography>
      <Button
        className={classes.coachCalloutButton}
        variant="contained"
        color="primary"
        href={COACH_SEARCH_URL}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<SearchIcon fontSize="small" opticalSize={18} />}
      >
        Browse coaches
      </Button>
    </Box>
  </Box>
)

const DiscoverMoreGolf = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <SessionSectionHeader title="Discover more golf" />

      <Box className={classes.discoverLayout}>
        <CoachCalloutCard classes={classes} />

        <Box className={classes.sideStack}>
          <DiscoverFeatureCard
            testId="discover-more-golf-jr-league"
            eyebrow="Junior Golf"
            title="PGA Jr. League"
            description="Team golf built for kids — jerseys, teammates and a season of scramble-format play."
            buttonLabel="Learn more"
            href={JR_LEAGUE_URL}
            icon={EmojiEventsIcon}
            classes={classes}
          />

          <DiscoverFeatureCard
            testId="discover-more-golf-events"
            eyebrow="Programs & Events"
            title="Something for every golfer"
            description="Clinics, leagues, beginner series and social nights near you — no handicap required."
            buttonLabel="Explore events"
            href={PROGRAMS_URL}
            icon={CelebrationIcon}
            classes={classes}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default DiscoverMoreGolf
